export default "__VITE_ASSET__196pWg8V__"